import {
    FETCH_FORGOTPASSWORD_FULFILLED,
    FETCH_FORGOTPASSWORD_REJECTED,
    FETCH_FORGOTPASSWORD_PENDING,
} from "../../actions/auth/forgotPassword";
const initialState = {
    done: false,
    error: {},
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_FORGOTPASSWORD_PENDING:
            return {
                done: false,
                error: {},
                spinner: true
            };
        case FETCH_FORGOTPASSWORD_FULFILLED:
            return {
                ...state,
                forgotPassword: action.payload,
                done: true,
                error: {},
                spinner: false
            };
        case FETCH_FORGOTPASSWORD_REJECTED:

            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        default:
            return state;
    }
};